/**
 * Adds the ACF rollover field image as a data-attribute to the native Featured
 * Image block
 *
 * TODO: Icon is featured image, but with a cursor overlaid
 */

import { SVG, Path } from "@wordpress/primitives";
import { registerBlockVariation } from "@wordpress/blocks";

import { addFilter } from "@wordpress/hooks";

const variationClassName = "post-featured-image-rollover";
const variationNamespace = `ideasonpurpose/${variationClassName}`;

const icon = "desktop";

export function rolloverHandler() {
  const rollovers = document.querySelectorAll(
    "figure.post-featured-image-rollover",
  );

  rollovers.forEach((fig) => {
    const src = fig.getAttribute("data-rollover-src");
    const srcset = fig.getAttribute("data-rollover-srcset");

    const img = fig.querySelector("a img");

    if (img) {
      const hover = img.cloneNode();
      hover.setAttribute("alt", ""); // accessibility
      if (src) {
        hover.setAttribute("src", src);
        hover.setAttribute("srcset", srcset);
      }
      img.insertAdjacentElement("afterend", hover);
    }
  });
}

export function registerFeaturedImageRollover() {
  registerBlockVariation("core/post-featured-image", {
    name: variationClassName,
    title: "Featured Image (Rollover)",
    description: "Use the ACF Rollover field value as the rollover image.",
    isActive: ["namespace"],
    icon,

    attributes: {
      namespace: variationNamespace,
      className: variationClassName,

      /**
       * `useFirstImageFromPost` is too slow to use, it triggers a bunch of tag parsing that we don't need
       * @link https://github.com/WordPress/wordpress-develop/blob/d77bb088452293775e2f16225141ceff9994b171/src/wp-includes/blocks/post-featured-image.php#L68
       */
      useFirstImageFromPost: false,
      isLink: true,
      aspectRatio: "1.618/1",
      align: "wide",
      style: { spacing: { margin: { bottom: "var:preset|spacing|50" } } },
    },

    scope: ["inserter", "transform"],

    // innerBlocks: [],
  });

  // addFilter(
  //   "blocks.registerBlockType",
  //   "ideasonpurpose.FeaturedImageRollover.RegisterBlockType",
  //   (settings, name) => {
  //     const newSettings = { ...settings };
  //     if (name === "core/post-featured-image") {
  //       /**
  //        * Add rolloverImage and namespace to block's attributes.
  //        * Namespace is used for verifying isActive
  //        */
  //       newSettings.attributes = {
  //         ...newSettings.attributes,
  //         rolloverImage: { type: "string", default: "" },
  //         namespace: { type: "string", default: "" },
  //       };
  //     }
  //     return newSettings;
  //   },
  // );

  addFilter(
    "blocks.registerBlockType",
    "ideasonpurpose.FeaturedImageRollover.RegisterBlockType",
    (settings, name) => {
      if (name !== "core/post-featured-image") {
        return settings;
      }

      const newSettings = { ...settings };

      newSettings.attributes = {
        ...newSettings.attributes,
        namespace: { type: "string", default: "" },
      };

      // Leftover from experimenting with PHP-defined variations (can't do custom Icons)
      // newSettings.variations = settings.variations.map((v) => {
      //   if (
      //     v.attributes?.namespace ===
      //     "ideasonpurpose/post-featured-image-rollover"
      //   ) {
      //     v.icon = icon;
      //   }

      //   return v;
      // });

      return newSettings;
    },
  );
}
